(function AuthNotificationConfigFindController() {
    'use strict';

    angular.module('AuthNotificationConfig')
        .controller('AuthNotificationConfigFindController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'authExtend', 'adminAuthNotificationConfigService', 'alerts', 'storageService','functionService',
            function authNotificationConfigFindController($scope, config, $state, $translate, errors, authExtend, adminAuthNotificationConfigService, alerts, storageService, functionService) {
                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.allApps = authExtend.isInRole('CONFIG ADMIN APPS');
                $scope.hideAddBtn = !authExtend.isInRole('AUTH NOTIFICATION WRITE');
                $scope.findAction = function () {
                    $scope.find.showNoData = false;
                    storageService.setAuthNotifFilter($scope.find);
                    storageService.setTYCPagination($scope.data);
                    return adminAuthNotificationConfigService.get($scope.find, $scope.data).then(function getOk(result) {
                        $scope.notificationsConfigs = result.value;
                        $scope.data.totalItems = result.totalCount;
                        $scope.data.from = 1 + ($scope.data.itemsPerPage * ($scope.data.currentPage - 1));

                        if ($scope.notificationsConfigs.length === 0)
                            $scope.find.showNoData = true;

                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.load = function () {
                    $scope.find = storageService.getAuthNotifFilter();
                    $scope.data = storageService.getTYCPagination();

                    if ($scope.find.notifEnabled == null) {
                        $scope.find.notifEnabled = "true";
                    }
                   
                    $scope.organizationalUnitId = authExtend.getOrganizationId()
                    if ($scope.allApps) {
                        functionService.getApps().then(function getOk(result) {
                            $scope.optionApps = result;
                            $scope.optionApps.unshift({
                                id: null,
                                name: ''
                            });
                            if ($scope.find.app == null) {
                                $scope.find.app = $scope.optionApps[0];
                            }
                        }, function getError(error) {
                            errors.showError(error);
                        });
                    } else {
                        $scope.find.app = {
                            id : config.appId()
                        };
                    }

                    $scope.notificationsConfigs = [];
                    $scope.findAction();
                }

                $scope.add = function () {
                    $state.go('auth-notification-config-add');
                };

                $scope.view = function (notificationConfig) {
                    $state.go('auth-notification-config-detail', { id: notificationConfig.id });
                };

                $scope.load();
            }
        ]);
})();